import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { captureException } from '@sentry/nextjs';
import { UserService } from '~/src/services/user.service';
import { setAgentIdAction } from '~/src/redux/user/user.slice';

const QUERY_KEY = 'autocomplete organizations';

export const useFetchGenerateAgentCode = () => {
    const dispatch = useDispatch();
    const { refetch, data } = useQuery([QUERY_KEY], () => UserService.getAgentCode(true), {
        onSuccess: (data) => {
            if (data) {
                dispatch(setAgentIdAction(data));
            }
        },
        onError: (error) => {
            captureException(error);
            // eslint-disable-next-line no-console
            console.log(QUERY_KEY, error);
        },
        enabled: false,
    });

    return { refetch, data };
};
